import AppFieldCard from "../../../elements/AppFieldCard";
import DocumentPicker from "../../CRM/DocumentPicker";
import { DocumentPageType } from "./ViewSpecificSection";

interface Props {
  documentPageType: DocumentPageType | undefined;
  setDocumentPageType: React.Dispatch<React.SetStateAction<DocumentPageType>>;
  document: string;
  setDocument: React.Dispatch<React.SetStateAction<string>>;
}

export default function DocumentSection({
  documentPageType,
  setDocumentPageType,
  document,
  setDocument,
}: Props) {
  return (
    <>
      <AppFieldCard
        full
        onClick={() => setDocumentPageType("Multiple")}
        isSelected={documentPageType === "Multiple"}
        icon={"file-document-multiple"}
        name={"Mulitple Documents"}
        description={
          "Allow users to browse, select, and switch between documents for editing. You can add any number of documents to this view."
        }
        css="mb-2"
      />
      <AppFieldCard
        full
        onClick={() => setDocumentPageType("Single")}
        isSelected={documentPageType === "Single"}
        icon={"file-document-outline"}
        name={"Single Document"}
        description={
          "For working on a single document at a time. This view removes distractions, providing a clean and focused workspace for displaying and editing a single document."
        }
        css="mb-4"
      />
      {documentPageType === "Single" && (
        <DocumentPicker value={document} onChange={setDocument} required />
      )}
    </>
  );
}
